/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { RoomPreferenceV2FromSelectionsBackfillResultDto } from '../models/RoomPreferenceV2FromSelectionsBackfillResultDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class RoomPreferenceV2FromSelectionsBackfillService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * @param force
     * @returns RoomPreferenceV2FromSelectionsBackfillResultDto OK
     * @throws ApiError
     */
    public postApiHousingRoomPreferenceV2FromSelectionsBackfillPreviewBackfill(
        force: boolean = false,
    ): CancelablePromise<RoomPreferenceV2FromSelectionsBackfillResultDto> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/housing/RoomPreferenceV2FromSelectionsBackfill/PreviewBackfill',
            query: {
                'force': force,
            },
            errors: {
                401: `Unauthorized`,
            },
        });
    }
    /**
     * @param force
     * @returns RoomPreferenceV2FromSelectionsBackfillResultDto OK
     * @throws ApiError
     */
    public postApiHousingRoomPreferenceV2FromSelectionsBackfillExecuteBackfill(
        force: boolean = false,
    ): CancelablePromise<RoomPreferenceV2FromSelectionsBackfillResultDto> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/housing/RoomPreferenceV2FromSelectionsBackfill/ExecuteBackfill',
            query: {
                'force': force,
            },
            errors: {
                401: `Unauthorized`,
            },
        });
    }
}
